"use client";

import { useState } from 'react';

export default function EducationDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'EXECUTIVE EDUCATION DASHBOARD',
      subtitle: 'Institutional Executive Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Executive Education Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Total Enrollment', value: '8,450', sub: '+4.2% YoY', color: '#1B2845' },
            { x: 186, label: 'Student Retention Rate', value: '87%', sub: '+2.1% vs LY', color: '#16a34a' },
            { x: 356, label: 'Institutional Revenue', value: '₹1,847Cr', sub: '+6.8% YoY', color: '#C5A572' },
            { x: 526, label: 'Graduation Rate', value: '91%', sub: 'Target: 90%', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Enrollment Trend */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Enrollment Trends (Students)</text>
          <polyline points="40,290 90,278 140,272 190,260 240,265 290,248 340,240 390,232 420,228" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="40,290 90,278 140,272 190,260 240,265 290,248 340,240 390,232 420,228 420,310 40,310 Z" fill="#1B2845" opacity="0.05" />
          {[40,90,140,190,240,290,340,390,420]?.map((x, i) => (
            <circle key={i} cx={x} cy={[290,278,272,260,265,248,240,232,228]?.[i]} r="3" fill="#C5A572" />
          ))}
          {['2016','2017','2018','2019','2020','2021','2022','2023','2024']?.map((y, i) => (
            <text key={i} x={[40,90,140,190,240,290,340,390,420]?.[i] - 8} y="308" fill="#9ca3af" fontSize="7" fontFamily="sans-serif">{y}</text>
          ))}

          {/* Program Profitability */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Program Profitability</text>
          {[
            { prog: 'Engineering', margin: 82, color: '#1B2845' },
            { prog: 'Management', margin: 76, color: '#C5A572' },
            { prog: 'Sciences', margin: 68, color: '#3b82f6' },
            { prog: 'Arts', margin: 54, color: '#8b5cf6' },
            { prog: 'Commerce', margin: 71, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x="460" y={178 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.prog}</text>
              <rect x="540" y={166 + i * 24} width={item?.margin * 1.3} height="12" fill={item?.color} rx="2" opacity="0.75" />
              <text x="546" y={176 + i * 24} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{item?.margin}%</text>
            </g>
          ))}

          {/* Scholarship Allocation */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Scholarship Allocation by Category (₹Cr)</text>
          {[
            { label: 'Merit-based', val: 85, color: '#1B2845' },
            { label: 'Need-based', val: 62, color: '#C5A572' },
            { label: 'Sports', val: 28, color: '#3b82f6' },
            { label: 'Research', val: 45, color: '#10b981' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x={28 + i * 165} y="362" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.label}</text>
              <rect x={28 + i * 165} y="366" width={bar?.val * 1.6} height="12" fill={bar?.color} rx="2" opacity="0.8" />
              <text x={34 + i * 165} y="376" fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">₹{bar?.val}Cr</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'ACADEMIC PERFORMANCE DASHBOARD',
      subtitle: 'Course & Faculty Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Academic Performance Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Avg Course Completion', value: '91%', sub: '+3.4% vs LY', color: '#16a34a' },
            { x: 186, label: 'Active Learners (DAU)', value: '6,284', sub: '74% of enrolled', color: '#1B2845' },
            { x: 356, label: 'Faculty Performance', value: '4.6/5', sub: 'Avg rating', color: '#C5A572' },
            { x: 526, label: 'At-Risk Students', value: '342', sub: '4.1% of total', color: '#dc2626' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Course Completion by Department */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Course Completion Rate by Department (%)</text>
          {[
            { dept: 'Engineering', rate: 94, color: '#1B2845' },
            { dept: 'Management', rate: 91, color: '#C5A572' },
            { dept: 'Sciences', rate: 88, color: '#3b82f6' },
            { dept: 'Arts', rate: 85, color: '#8b5cf6' },
            { dept: 'Commerce', rate: 90, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x="28" y={178 + i * 26} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.dept}</text>
              <rect x="120" y={166 + i * 26} width={item?.rate * 2.8} height="14" fill={item?.color} rx="2" opacity="0.75" />
              <text x="126" y={177 + i * 26} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{item?.rate}%</text>
            </g>
          ))}

          {/* Learning Engagement Trend */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Daily Active Learners</text>
          <polyline points="460,290 490,275 520,268 550,255 580,260 610,242 640,235 668,228" fill="none" stroke="#C5A572" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="460,290 490,275 520,268 550,255 580,260 610,242 640,235 668,228 668,310 460,310 Z" fill="#C5A572" opacity="0.06" />
          {[460,490,520,550,580,610,640,668]?.map((x, i) => (
            <circle key={i} cx={x} cy={[290,275,268,255,260,242,235,228]?.[i]} r="3" fill="#1B2845" />
          ))}

          {/* At-Risk Students */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">At-Risk Student Indicators</text>
          {[
            { label: 'Low Attendance', count: 142, color: '#dc2626', bg: '#fef2f2' },
            { label: 'Failing Grades', count: 98, color: '#d97706', bg: '#fffbeb' },
            { label: 'Low Engagement', count: 102, color: '#d97706', bg: '#fffbeb' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x={28 + i * 220} y="355" width="200" height="40" rx="6" fill={item?.bg} />
              <text x={38 + i * 220} y="372" fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.label}</text>
              <text x={38 + i * 220} y="386" fill={item?.color} fontSize="12" fontWeight="bold" fontFamily="sans-serif">{item?.count} students</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'STUDENT SUCCESS DASHBOARD',
      subtitle: 'Retention & Engagement Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Student Success Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Engagement Score', value: '78%', sub: '+4.2% MoM', color: '#16a34a' },
            { x: 186, label: 'Retention Rate', value: '87%', sub: 'Target: 85%', color: '#1B2845' },
            { x: 356, label: 'Interventions Active', value: '284', sub: '82% effective', color: '#C5A572' },
            { x: 526, label: 'LMS Usage Rate', value: '74%', sub: '+6.1% vs LY', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Academic Progress by Year */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Academic Progress by Cohort Year (%)</text>
          {[
            { year: 'Year 1 (2024)', progress: 88, color: '#1B2845' },
            { year: 'Year 2 (2023)', progress: 91, color: '#C5A572' },
            { year: 'Year 3 (2022)', progress: 87, color: '#3b82f6' },
            { year: 'Year 4 (2021)', progress: 93, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x="28" y={180 + i * 30} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.year}</text>
              <rect x="140" y={168 + i * 30} width={item?.progress * 2.6} height="16" fill={item?.color} rx="3" opacity="0.75" />
              <text x="148" y={180 + i * 30} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{item?.progress}%</text>
            </g>
          ))}

          {/* Retention Risk */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Retention Risk Indicators</text>
          {[
            { risk: 'High Risk', count: 98, color: '#dc2626', bg: '#fef2f2' },
            { risk: 'Medium Risk', count: 156, color: '#d97706', bg: '#fffbeb' },
            { risk: 'Low Risk', count: 88, color: '#16a34a', bg: '#f0fdf4' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x="460" y={165 + i * 42} width="210" height="34" rx="6" fill={item?.bg} />
              <text x="472" y={180 + i * 42} fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.risk}</text>
              <text x="472" y={193 + i * 42} fill={item?.color} fontSize="12" fontWeight="bold" fontFamily="sans-serif">{item?.count} students</text>
            </g>
          ))}

          {/* Intervention Effectiveness */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Intervention Effectiveness — GPA Before vs After</text>
          {[
            { label: 'Academic Counseling', before: 2.1, after: 3.2, color: '#1B2845' },
            { label: 'Peer Tutoring', before: 2.4, after: 3.4, color: '#C5A572' },
            { label: 'Faculty Mentoring', before: 2.2, after: 3.5, color: '#3b82f6' },
            { label: 'Online Resources', before: 2.6, after: 3.1, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x={28 + i * 165} y="362" fill="#6b7280" fontSize="8" fontFamily="sans-serif">{item?.label}</text>
              <rect x={28 + i * 165} y="366" width={item?.before * 28} height="6" fill="#dc2626" rx="1" opacity="0.5" />
              <rect x={28 + i * 165} y="374" width={item?.after * 28} height="6" fill={item?.color} rx="1" opacity="0.8" />
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Education Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Real-time dashboards built for every level of academic leadership.</p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards?.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40'
              }`}
            >
              {d?.title}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards?.[activeTab]?.subtitle}</h3>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards?.[activeTab]?.svg}
          </div>
        </div>
      </div>
    </section>
  );
}
